var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "password-ico",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.128,
    height: 41.434,
    viewBox: "0 0 33.128 41.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 33.128,
    height: 41.434,
    fill: "#6b727c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M33.088,19.4a.169.169,0,0,0,0-.019c0-.013,0-.027,0-.04a3.14,3.14,0,0,0-.188-1.138,5.643,5.643,0,0,0-5.318-3.691c-.491-.009-.519-.034-.529-.5-.03-1.391.015-2.781-.074-4.174A10.358,10.358,0,0,0,14.9.122,10.305,10.305,0,0,0,6.411,8.23a17.387,17.387,0,0,0-.267,3.254q-.02,1.293,0,2.585c.006.338-.124.472-.456.45a4.864,4.864,0,0,0-1.111.1A5.59,5.59,0,0,0,0,20.075C.067,25.43.019,30.787.022,36.143a4.344,4.344,0,0,0,.2,1.528A5.341,5.341,0,0,0,4.8,41.434H28.306a4.6,4.6,0,0,0,2.568-.929A5.219,5.219,0,0,0,33.128,36.7v-16.8a1.084,1.084,0,0,1-.04-.49M9.05,14.25c.028-1.478-.033-2.96.051-4.435a7.522,7.522,0,0,1,14.825-1.19,10.21,10.21,0,0,1,.208,2.351c0,1.09-.013,2.182.008,3.273.006.32-.072.406-.4.4-2.382-.016-4.763-.008-7.146-.008s-4.763-.008-7.145.008c-.326,0-.406-.081-.4-.4M27.39,38.677H5.871a2.777,2.777,0,0,1-3.053-3.032q0-7.622,0-15.244a2.774,2.774,0,0,1,3-3H27.385a2.77,2.77,0,0,1,2.988,2.97q0,7.667,0,15.33a2.767,2.767,0,0,1-2.983,2.974",
    transform: "translate(0 0)",
    fill: "#6b727c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M24.8,38.052a.953.953,0,0,0-.226.66c.01.9.009,1.808,0,2.712a1.394,1.394,0,0,1-1.546,1.541c-.258,0-.517.006-.775,0a1.374,1.374,0,0,1-1.419-1.406c-.016-.5,0-1,0-1.506,0-.187,0-.374,0-.56a2.847,2.847,0,0,0-.438-1.805,2.562,2.562,0,0,1,.706-3.442,2.676,2.676,0,0,1,3.7,3.808",
    transform: "translate(-6.109 -10.297)",
    fill: "#6b727c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIco);
export default __webpack_public_path__ + "static/media/password-ico.b3944cf13440a579dc43ba3098f9c105.svg";
export { ForwardRef as ReactComponent };